<ol class="stepper" role="list">
  @for (step of stepViews(); track step.number; let last = $last) {
    <li
      class="stepper__item"
      role="listitem"
      [attr.data-state]="step.state"
      [attr.aria-current]="step.state === 'active' ? 'step' : null">
      @if (isInteractive(step)) {
        <button
          type="button"
          class="stepper__node stepper__node--button"
          [attr.aria-label]="stepAriaLabel(step)"
          (click)="handleSelect(step)">
          <span class="stepper__circle" aria-hidden="true">
            @if (step.state === 'complete') {
              <i class="bx bx-check"></i>
            } @else {
              {{ step.number }}
            }
          </span>
          <span class="stepper__text">
            <span class="stepper__label">{{ step.label }}</span>
            @if (step.description) {
              <span class="stepper__description">{{ step.description }}</span>
            }
          </span>
        </button>
      } @else {
        <div class="stepper__node" [attr.aria-label]="stepAriaLabel(step)">
          <span class="stepper__circle" aria-hidden="true">
            @if (step.state === 'complete') {
              <i class="bx bx-check"></i>
            } @else {
              {{ step.number }}
            }
          </span>
          <span class="stepper__text">
            <span class="stepper__label">{{ step.label }}</span>
            @if (step.description) {
              <span class="stepper__description">{{ step.description }}</span>
            }
          </span>
        </div>
      }
      @if (!last) {
        <span class="stepper__bar" aria-hidden="true"></span>
      }
    </li>
  }
</ol>
